export default "__VITE_ASSET__BIYOLBkQ__"